import { FC } from 'react';
import { FieldRow, FieldLabel, Panel, Title } from 'src/generic/component';
import { TextArea } from 'src/generic/component/form';
import { IFieldErrors, ErrorManager } from 'src/types/validation';
import { Draft } from 'src/types/common';
import { IAIRequest } from 'src/types/org/ai/schoolInterface';

interface ISubmitterCommentsPanelProps {
  item: Draft<IAIRequest>;
  readOnly?: boolean;
  errors: IFieldErrors;
  onUpdate: (updates: Draft<IAIRequest>) => void;
}

export const SubmitterCommentsPanel: FC<ISubmitterCommentsPanelProps> = ({
  item,
  readOnly,
  errors,
  onUpdate
}) => {
  const { getError, hasError } = ErrorManager(errors);

  const appForm = item.data?.appForm;
  const submitterComments = appForm?.submitterComments || '';

  const changed = (submitterComments: string) => {
    const updatedItem: Draft<IAIRequest> = {
      ...item,
      data: {
        ...item.data,
        appForm: {
          ...appForm,
          submitterComments
        }
      }
    };
    onUpdate(updatedItem);
  };

  return (
    <Panel>
      <Title>Submitter Comments</Title>
      <FieldRow>
        <TextArea
          disabled={readOnly}
          validation={hasError('data.appForm.submitterComments') ? 'error' : undefined}
          validationMsg={getError('data.appForm.submitterComments')}
          onChange={(e) => {
            changed(e.target.value);
          }}
          value={submitterComments}
          placeholder="Please provide any additional comments or information that may be helpful for processing your request..."
          rows={4}
        />
      </FieldRow>
    </Panel>
  );
};